import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { MENUITEM_IDS } from '@/lib/constants';
import { useParams } from 'react-router-dom';
import { PageEditor } from '@/features/product-editor/components/PageEditor';

export default function EditProductPage() {
    useBreadcrumbs([
        { title: 'My Products', to: '/stores/:storeId/page/product', id: MENUITEM_IDS.STORE, active: false },
        { title: 'Edit Product', to: '/stores/:storeId/page/product/:pageId', id: '', active: true },
    ]);

    const { storeId, pageId, pageType } = useParams<{ storeId: string; pageId: string; pageType: string }>();

    if (!storeId || !pageType) {
        return <div>Invalid parameters</div>;
    }

    return <PageEditor storeId={storeId} pageId={pageId} pageType={pageType} />;
}
